import { render, staticRenderFns } from "./Followup.vue?vue&type=template&id=0e980a57&scoped=true"
import script from "./Followup.vue?vue&type=script&lang=js"
export * from "./Followup.vue?vue&type=script&lang=js"
import style0 from "./Followup.vue?vue&type=style&index=0&id=0e980a57&prod&scoped=true&lang=stylus&rel=stylesheet%2Fstylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e980a57",
  null
  
)

export default component.exports